import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/chart";
import { CartesianGrid, Line, LineChart, ReferenceLine, XAxis, YAxis } from "recharts";

// 3 working days = 259200 business seconds → displayed as days
const TASKS_GOAL_DAYS = 259200 / 86400;

const chartConfig = {
  median_days: {
    label: "Median cycle time (days)",
    color: "hsl(var(--chart-1))",
  },
} satisfies ChartConfig;

type TasksChartProps = {
  data: { week_start_utc: string; median_cycle_seconds: number }[];
};

export function TasksChart({ data }: TasksChartProps) {
  const chartData = data.map(d => ({
    week_start_utc: d.week_start_utc,
    median_days: parseFloat((d.median_cycle_seconds / 86400).toFixed(2)),
  }));

  return (
    <ChartContainer config={chartConfig} className="min-h-[200px]">
      <LineChart data={chartData}>
        <CartesianGrid vertical={false} />
        <XAxis dataKey="week_start_utc" tickLine={false} axisLine={false} tickMargin={8} />
        <YAxis tickLine={false} axisLine={false} tickMargin={8} unit="d" />
        <ChartTooltip content={<ChartTooltipContent />} />
        <ReferenceLine
          y={TASKS_GOAL_DAYS}
          stroke="hsl(var(--chart-2))"
          strokeDasharray="4 4"
          label={{
            value: `Goal: ${TASKS_GOAL_DAYS}d`,
            position: "insideTopRight",
            fill: "hsl(var(--chart-2))",
            fontSize: 12,
          }}
        />
        <Line dataKey="median_days" type="monotone" stroke="var(--color-median_days)" strokeWidth={2} dot={false} />
      </LineChart>
    </ChartContainer>
  );
}
